import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getCategories = async () => {
  const response = await api.get('/categories.php');
  return response.data;
};

export const getCategoryBySlug = async (slug) => {
  const response = await api.get(`/categories.php?slug=${slug}`);
  return response.data;
};

export const getPosts = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await api.get(`/posts.php?${queryString}`);
  return response.data;
};

export const getPostBySlug = async (slug) => {
  const response = await api.get(`/posts.php?slug=${slug}`);
  return response.data;
};

export const searchPosts = async (query, page = 1) => {
  const response = await api.get(`/search.php?q=${encodeURIComponent(query)}&page=${page}`);
  return response.data;
};

export const submitContactForm = async (formData) => {
  const response = await api.post('/contact.php', 
    new URLSearchParams(formData).toString(),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }
  );
  return response.data;
};

export const subscribeNewsletter = async (email, name = '', source = 'home') => {
  const response = await api.post('/newsletter.php', {
    email,
    name,
    source
  });
  return response.data;
};

export default api;
